<div class="content">
    <div class="content-panel">
        <!-- Filtres -->
        <div class="p-3">
            <p-accordion [value]="accordionValue" (valueChange)="onAccordionChange($event)">
                <p-accordion-panel value="0">
                    <p-accordion-header>
                        <div class="d-flex justify-content-start align-items-center gap-3">
                            <i class="pi pi-filter"></i>
                            <span>{{ 'page.commissions.synthese-jure.search.filters' | translate }}</span>
                            @if (this.activeFilters > 0) {
                                <p-badge [value]="activeFilters" severity="secondary"></p-badge>
                            }
                        </div>
                    </p-accordion-header>
                    <p-accordion-content>
                        <form [formGroup]="formSearchCommissions" (ngSubmit)="onSubmit()">
                            <div class="d-flex flex-wrap gap-3 pb-3">
                                <!-- Filtre Date(s) commission -->
                                <p-floatlabel variant="on" class="flex-grow-1">
                                    <p-datePicker
                                        id="datesCommission"
                                        formControlName="rangeDates"
                                        selectionMode="range"
                                        dateFormat="dd/mm/yy"
                                        [iconDisplay]="'input'"
                                        [showIcon]="true"
                                        [showClear]="true">
                                    </p-datePicker>
                                    <label for="datesCommission">{{ 'page.commissions.synthese-jure.search.date-commission' | translate }}</label>
                                </p-floatlabel>
                                <!-- Filtre College -->
                                <p-floatlabel variant="on" class="flex-grow-1">
                                    <p-select
                                        id="collegeCommission"
                                        formControlName="collegeCommission"
                                        [options]="collegeList"
                                        optionLabel="libelle"
                                        [checkmark]="true"
                                        [showClear]="true">
                                    </p-select>
                                    <label for="collegeCommission">{{ 'page.commissions.synthese-jure.search.college' | translate }}</label>
                                </p-floatlabel>
                                <!-- Filtre Cahiers des charges -->
                                <p-floatlabel variant="on" class="w-50">
                                    <p-multiSelect
                                        id="cahierCommission"
                                        formControlName="cahierCommission"
                                        [options]="cahiersList"
                                        optionLabel="libelle"
                                        display="chip">
                                    </p-multiSelect>
                                    <label for="cahierCommission">{{ 'page.commissions.synthese-jure.search.cahiers' | translate }}</label>
                                </p-floatlabel>
                            </div>
                            <div class="d-flex justify-content-end">
                                <!-- Bouton de recherche -->
                                <p-button class="outline" label="{{ 'label.filtrer' | translate }}" icon="pi pi-search" type="submit" [outlined]="true"></p-button>
                            </div>
                        </form>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
        </div>
        <!-- Synthèse des jurés -->
        @if (syntheses?.length > 0) {
            <!-- Bouton d'export -->
            <div class="ps-3 pb-3">
                <p-button
                    label="{{ 'label.exporter' | translate }}"
                    icon="pi pi-file-excel"
                    type="button"
                    (click)="onExport()"
                    [disabled]="syntheses.length === 0"
                    (keydown.enter)="onExport()">
                </p-button>
            </div>
            <!-- Nombre de lignes -->
            <div >
                {{ dt?.filteredValue?.length ?? syntheses.length }}
                / {{ syntheses.length }}
            </div>
            <!-- Tableau -->
            <p-table
                #dt
                [value]="syntheses"
                [paginator]="true"
                [rows]="30"
                [scrollable]="true"
                [scrollHeight]="tableScrollHeight">
                <ng-template pTemplate="header">
                    <tr>
                        @for (col of columns; track col) {
                            <th scope="col"
                                [pSortableColumn]="col.field"
                                [style.min-width]="col.width"
                                pFrozenColumn
                                [frozen]="col.frozen">
                                {{ col.label | translate }}
                                @if (col.field === 'nom' || col.field === 'mail') {
                                    <p-sortIcon [field]="col.field" />
                                    <p-columnFilter type="{{ col.filter }}" field="{{ col.field }}" display="menu" [showOperator]="false" />
                                }
                            </th>
                        }
                        <th scope="col"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-synthese>
                    <tr>
                        @for (col of columns; track col) {
                            @if (col.field === 'evaluation') {
                                <td [style.min-width]="col.width"
                                    pFrozenColumn
                                    [frozen]="col.frozen">
                                    {{ calculPoints(synthese.id) }} / {{ calculMaxPoints(synthese.id) }}
                                </td>
                            } @else {
                                <td [style.min-width]="col.width"
                                    pFrozenColumn
                                    [frozen]="col.frozen">
                                    {{ synthese[col.field] }}
                                </td>
                            }
                        }
                        <td>
                            <p-button
                                icon="pi pi-address-book"
                                aria-label="Détail"
                                [pTooltip]="'page.commissions.synthese-jure.modals.detail' | translate: {jure: synthese.nom}"
                                tooltipPosition="left"
                                class="buttonIcon"
                                (click)="viewDetail(synthese)"
                                (keydown.enter)="viewDetail(synthese)"
                                [outlined]="true">
                            </p-button>
                            <p-button
                                icon="pi pi-list-check"
                                aria-label="Évaluation"
                                [pTooltip]="'page.commissions.synthese-jure.modals.evaluation' | translate: {jure: synthese.nom}"
                                tooltipPosition="left"
                                class="buttonIcon"
                                (click)="viewEvaluation(synthese)"
                                (keydown.enter)="viewEvaluation(synthese)"
                                [outlined]="true">
                            </p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        } @else {
            <p class="text-center">{{ 'page.commissions.synthese-jure.search.aucuneSynthese' | translate }}</p>
        }
    </div>
</div>

@if (showDetailModal()) {
    <app-detail-synthese
        [(visible)]="showDetailModal"
        [detailJures]="detailJures"
        [jure]="selectedJure">
    </app-detail-synthese>
}

@if (showEvaluationModal()) {
    <app-detail-evaluation
        [(visible)]="showEvaluationModal"
        [idOrganisme]="idOrganisme"
        [jure]="selectedJure"
        [selectedDateDebut]="selectedDateDebut"
        [selectedDateFin]="selectedDateFin"
        [selectedCahiers]="cahiers.value"
        [cahiersList]="cahiersList">
    </app-detail-evaluation>
}
